<template>
  <div id="locale-changer" :class="{ 'mobile-local-changer': isMobile }">
    <b-button-group>
      <b-button class="flag_lang_button" @click="$i18n.locale = 'fr'"><img
          src="https://sportips.fr/live/img/Flags/FRA.jpg" alt=""></b-button>
      <b-button class="flag_lang_button" @click="$i18n.locale = 'en'"><img
          src="https://sportips.fr/live/img/Flags/GBR.jpg" alt=""></b-button>
    </b-button-group>
  </div>
</template>

<script>

export default {
  name: 'locale-changer',
  data() {
    return { langs: ['fr', 'en'] }
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  }
}
</script>

<style lang="scss" scoped></style>